// Product navigation on the main site (Phase 2 of docs/nav-handoff/TASK.md).
// Off unless VITE_PB_PRODUCT_NAV=1 at build / dev time; with it off this file
// does nothing and the site is exactly as before.
//
// With it on:
//   - the header's "Products" item opens the All Products panel (from
//     /_nav/pentabay-bar.js) instead of the plain dropdown list;
//   - dev preview of product mode: add ?pb-product=<id> to any page URL, e.g.
//     /about?pb-product=ava. The main header is swapped for the product-mode
//     bar exactly as a product site would show it.
export function initProductNav() {
  if (import.meta.env.VITE_PB_PRODUCT_NAV !== '1') return
  if (document.querySelector('script[data-pb-product-nav]')) return

  const preview = new URLSearchParams(location.search).get('pb-product')
  const style = document.createElement('style')
  style.textContent =
    // the plain Products list is replaced by the panel
    '#nav .pbf-has-dd:has(> [data-pbf-products]) > .pbf-dd{display:none}' +
    '#nav .pbf-has-dd > a[data-pbf-products]{cursor:pointer}' +
    (preview ? '#nav{display:none!important}' : '')
  document.head.appendChild(style)

  const s = document.createElement('script')
  s.src = '/_nav/pentabay-bar.js'
  s.dataset.pbProductNav = ''
  if (preview) {
    s.dataset.product = preview
    s.dataset.home = '/'
  }
  document.head.appendChild(s)
  // the SPA mounts the header after this runs, so label it whenever it appears
  const label = () => {
    for (const a of document.querySelectorAll('#nav a[data-pbf-products]:not([aria-controls])')) {
      a.setAttribute('aria-haspopup', 'dialog')
      a.setAttribute('aria-expanded', 'false')
      a.setAttribute('aria-controls', 'pb-all-products')
    }
  }
  label()
  new MutationObserver(label).observe(document.documentElement, { childList: true, subtree: true })

  // Runs in the capture phase on window, ahead of frame.js's document-level
  // handler that turns top-level menu clicks into no-ops.
  window.addEventListener(
    'click',
    (e) => {
      const a = e.target.closest?.('#nav a[data-pbf-products]')
      if (!a || !window.PentabayNav?.openPanel) return
      e.preventDefault()
      e.stopImmediatePropagation()
      if (a.getAttribute('aria-expanded') === 'true') return window.PentabayNav.closePanel()
      window.PentabayNav.openPanel({ trigger: a, top: document.getElementById('nav').getBoundingClientRect().bottom, source: 'pb-menu' })
    },
    true,
  )
}
